import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3164ccb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_3 = {
  class: "home-card-item home-card-item-box",
  style: { background: '#8595F4' }
}
const _hoisted_4 = { class: "home-card-item-flex" }
const _hoisted_5 = { class: "home-card-item-title pb3" }
const _hoisted_6 = { class: "home-card-item-title pb3" }
const _hoisted_7 = { class: "home-card-item-title pb3" }
const _hoisted_8 = { class: "home-card-item-title pb3" }
const _hoisted_9 = { class: "home-card-item-title pb3" }
const _hoisted_10 = { class: "home-card-item-title pb3" }
const _hoisted_11 = { class: "home-card-item-title pb3" }
const _hoisted_12 = { class: "home-card-item-title pb3" }
const _hoisted_13 = { class: "home-card-item-title pb3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 5 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 20,
          sm: 6,
          class: "mb15"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.jsm,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.jsm) = $event)),
              placeholder: "检索码或品名",
              size: "small"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 4,
          sm: 4,
          class: "mb15"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: $setup.search
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { gutter: 10 }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodslist, (v, k) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            sm: 6,
            class: "mb10",
            key: k
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, "商品编码：" + _toDisplayString(v.spbh), 1),
                  _createElementVNode("div", _hoisted_6, "检索码：" + _toDisplayString(v.jsm), 1),
                  _createElementVNode("div", _hoisted_7, "品名：" + _toDisplayString(v.pm), 1),
                  _createElementVNode("div", _hoisted_8, "规格：" + _toDisplayString(v.gg), 1),
                  _createElementVNode("div", _hoisted_9, "采购员：" + _toDisplayString(v.dw), 1),
                  _createElementVNode("div", _hoisted_10, "库存数量：" + _toDisplayString(v.bz), 1),
                  _createElementVNode("div", _hoisted_11, "生产厂家：" + _toDisplayString(v.sccj), 1),
                  _createElementVNode("div", _hoisted_12, "批发价：" + _toDisplayString(v.pfj), 1),
                  _createElementVNode("div", _hoisted_13, "中标价：" + _toDisplayString(v.lsj), 1)
                ])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ], 512)), [
    [_directive_loading, _ctx.loading]
  ])
}